import clsx from 'clsx';

export interface DocumentUnlockSectionProps {
    renderUnlock: () => React.ReactNode;
    className?: string;
}

export const DocumentUnlockSection: React.FC<DocumentUnlockSectionProps> = ({
    renderUnlock,
    className
}) => {
    return (
        <div className={clsx(
            'flex flex-col gap-6',
            className
        )}>
            <div className='flex flex-col gap-4 px-5'>
                <h1 className='text-2xl md:text-3xl font-medium text-[#0b111e] mb-1 text-center'>Odemknout dokument</h1>
                {renderUnlock()}
            </div>
        </div>
    );
};
